import React from "react";

function PaymentPendingIllustration() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 652.095 553.219"
    >
      <g data-name="Group 3331" transform="translate(-15342.878 -8854.781)">
        <g data-name="Group 3330" transform="translate(224.878 879.781)">
          <path
            fill="#e6e6e6"
            d="M668.565 259.769h-19.333a3.722 3.722 0 01-3.718-3.718v-19.333a3.722 3.722 0 013.718-3.718h19.333a3.722 3.722 0 013.718 3.718v19.333a3.722 3.722 0 01-3.718 3.718zm-19.333-25.282a2.233 2.233 0 00-2.232 2.231v19.333a2.233 2.233 0 002.231 2.231h19.333a2.233 2.233 0 002.231-2.231v-19.333a2.233 2.233 0 00-2.231-2.231z"
            data-name="Path 5733"
            transform="translate(14832.376 7857.254)"
          ></path>
          <path
            fill="#e6e6e6"
            d="M365.565 104.769h-19.333a3.722 3.722 0 01-3.718-3.718V81.718A3.722 3.722 0 01346.232 78h19.333a3.722 3.722 0 013.718 3.718v19.333a3.722 3.722 0 01-3.718 3.718zm-19.333-25.282A2.233 2.233 0 00344 81.718v19.333a2.233 2.233 0 002.231 2.231h19.333a2.233 2.233 0 002.231-2.231V81.718a2.233 2.233 0 00-2.231-2.231z"
            data-name="Path 5734"
            transform="translate(14910.073 7897)"
          ></path>
          <path
            fill="#e6e6e6"
            d="M652.565 246.769h-19.333a3.722 3.722 0 01-3.718-3.718v-19.333a3.722 3.722 0 013.718-3.718h19.333a3.722 3.722 0 013.718 3.718v19.333a3.722 3.722 0 01-3.718 3.718zm-19.333-25.282a2.233 2.233 0 00-2.232 2.231v19.333a2.233 2.233 0 002.231 2.231h19.333a2.233 2.233 0 002.231-2.231v-19.333a2.233 2.233 0 00-2.231-2.231z"
            data-name="Path 5735"
            transform="translate(14836.479 7860.587)"
          ></path>
          <path
            fill="#e6e6e6"
            d="M200.565 463.769h-19.333a3.722 3.722 0 01-3.718-3.718v-19.333a3.722 3.722 0 013.718-3.718h19.333a3.722 3.722 0 013.718 3.718v19.333a3.722 3.722 0 01-3.718 3.718zm-19.333-25.282a2.233 2.233 0 00-2.232 2.231v19.333a2.233 2.233 0 002.231 2.231h19.333a2.233 2.233 0 002.231-2.231v-19.333a2.233 2.233 0 00-2.231-2.231z"
            data-name="Path 5736"
            transform="translate(14952.384 7804.943)"
          ></path>
          <path
            fill="#e6e6e6"
            d="M184.565 450.769h-19.333a3.722 3.722 0 01-3.718-3.718v-19.333a3.722 3.722 0 013.718-3.718h19.333a3.722 3.722 0 013.718 3.718v19.333a3.722 3.722 0 01-3.718 3.718zm-19.333-25.282a2.233 2.233 0 00-2.232 2.231v19.333a2.233 2.233 0 002.231 2.231h19.333a2.233 2.233 0 002.231-2.231v-19.333a2.233 2.233 0 00-2.231-2.231z"
            data-name="Path 5737"
            transform="translate(14956.486 7808.277)"
          ></path>
          <path
            fill="#3f3d56"
            d="M245.8 164.038h178.916a38.034 38.034 0 0137.1 29.669l90.4 400.985a30.74 30.74 0 01-28.474 37.463l-183.926 9.062a40.61 40.61 0 01-41.96-33.333l-51.282-283.5-3.815 1.09-9.812-53.734 3.927-.982-14.315-79.135a23.417 23.417 0 0123.241-27.585z"
            data-name="Path 5738"
            transform="translate(14940.928 7874.938)"
          ></path>
          <path
            fill="#fff"
            d="M407.251 175.664h20.885a26.284 26.284 0 0125.68 20.681l86.774 397.714a16.287 16.287 0 01-14.847 19.724L342.412 625.8a21.093 21.093 0 01-22.138-17.308l-74.045-411.079a18.475 18.475 0 0118.182-21.75h19.813a8.719 8.719 0 018.419 6.452 7.7 7.7 0 007.433 5.7h94.057a13.158 13.158 0 0013.119-12.149z"
            data-name="Path 5739"
            transform="translate(14934.838 7871.957)"
          ></path>
          <path
            fill="#68b030"
            d="M104 188.606h198.888l21.188 95.47-201.487 3.718z"
            data-name="Path 5740"
            transform="translate(15091.332 7926.637)"
          ></path>
          <path
            fill="#168947"
            d="M358 431.754h46.824l1.487 8.964h-46.824z"
            data-name="Path 5741"
            transform="translate(15026.199 7864.287)"
          ></path>
          <path
            fill="#2f2e41"
            d="M0 0H198.627V0.935H0z"
            data-name="Rectangle 1487"
            transform="rotate(-1.213 397497.672 -714934.602)"
          ></path>
          <path
            fill="#2f2e41"
            d="M0 0H202.374V0.935H0z"
            data-name="Rectangle 1488"
            transform="matrix(1 -.023 .023 1 15226.049 8282.552)"
          ></path>
          <path
            fill="#168947"
            d="M384 560.754h46.824l1.487 8.964h-46.824z"
            data-name="Path 5742"
            transform="translate(15019.532 7831.208)"
          ></path>
          <path
            fill="#2f2e41"
            d="M0 0H198.627V0.935H0z"
            data-name="Rectangle 1489"
            transform="rotate(-1.213 402037.976 -715799.797)"
          ></path>
          <path
            fill="#2f2e41"
            d="M0 0H202.374V0.935H0z"
            data-name="Rectangle 1490"
            transform="matrix(1 -.023 .023 1 15245.382 8378.473)"
          ></path>
          <path
            fill="#a0616a"
            d="M611.051 719.422h-8.86l-4.215-34.172h13.076z"
            data-name="Path 5743"
            transform="translate(14964.663 7799.285)"
          ></path>
          <path
            fill="#2f2e41"
            d="M770.261 816.8h-28.568v-.361a11.12 11.12 0 0111.118-11.119h17.449z"
            data-name="Path 5744"
            transform="translate(14807.713 7710.498)"
          ></path>
          <path
            fill="#a0616a"
            d="M756.486 711.934l-8.623 2.031-11.937-32.3 12.728-3z"
            data-name="Path 5745"
            transform="translate(14929.29 7800.971)"
          ></path>
          <path
            fill="#2f2e41"
            d="M920.975 808.1l-27.807 6.548-.083-.352a11.12 11.12 0 018.274-13.372l16.983-4z"
            data-name="Path 5746"
            transform="translate(14768.969 7712.65)"
          ></path>
          <path
            fill="#2f2e41"
            d="M769.342 594.7c.017-1.781.544-43.808 12.064-59.7l.17-.234 40.147 5.539-.9 8.821c1.766 1.718 15.656 16.232 19.667 50.6l42.613 114.447-19.81 1.8-58.64-124.931-31.033 135.8h-19.639z"
            data-name="Path 5747"
            transform="translate(14804.563 7779.874)"
          ></path>
          <path
            fill="#ccc"
            d="M784.539 513.057l3.924-20.6c-.768-.989-4.172-5.738-3.414-11.305.494-3.632 2.662-6.817 6.445-9.468l10.172-23.735.137-.08c.685-.4 16.881-9.769 25.711-.933.221.171 21.96 17.428 13.23 40.707l-10.777 32.335z"
            data-name="Path 5748"
            transform="translate(14796.727 7803.366)"
          ></path>
          <path
            fill="#a0616a"
            d="M763.347 564.568a7.286 7.286 0 006.153-9.324l21.007-15.135-12.575-4.783-18.02 15.106a7.325 7.325 0 003.436 14.137z"
            data-name="Path 5749"
            transform="translate(14804.265 7779.73)"
          ></path>
          <path
            fill="#ccc"
            d="M771.369 516.734l32.07-25.267-9.539-32.575a11.7 11.7 0 011.181-9.263 10.825 10.825 0 017.1-5.124c5.49-1.162 10.474 1.912 14.81 9.138l.033.065c.717 1.754 17.425 43.054 4.668 51.886-12.479 8.639-41.417 21.216-41.708 21.342l-.339.147z"
            data-name="Path 5750"
            transform="translate(14800.104 7803.08)"
          ></path>
          <circle
            cx="19.428"
            cy="19.428"
            r="19.428"
            fill="#a0616a"
            data-name="Ellipse 1457"
            transform="translate(15594.667 8202.853)"
          ></circle>
          <circle
            cx="17.187"
            cy="17.187"
            r="17.187"
            fill="#2f2e41"
            data-name="Ellipse 1458"
            transform="translate(15627.366 8180.97)"
          ></circle>
          <path
            fill="#2f2e41"
            d="M880.437 391.712a17.188 17.188 0 01-26.542-9.025 17.188 17.188 0 1033.528-7.048 17.182 17.182 0 01-6.986 16.073z"
            data-name="Path 5751"
            transform="translate(14778.942 7820.678)"
          ></path>
          <path
            fill="#2f2e41"
            d="M798.37 392.607c3-5.372 4.149-7.616 8.017-10.882 3.421-2.889 7.629-3.737 11.023-1a20.445 20.445 0 11-12.126 16.36c-2.949-.414-3.963-4.063-6.914-4.478z"
            data-name="Path 5752"
            transform="translate(14793.18 7819.801)"
          ></path>
          <path
            fill="#3f3d56"
            d="M939.532 821.487H656.23a.744.744 0 110-1.487h283.3a.744.744 0 010 1.487z"
            data-name="Path 5753"
            transform="translate(14829.819 7706.732)"
          ></path>
        </g>
        <g data-name="Group 3329" transform="translate(-800.201 820.895)">
          <circle
            cx="82.261"
            cy="82.261"
            r="82.261"
            fill="#3f3d56"
            data-name="Ellipse 1462"
            transform="translate(16380.354 8311.956)"
          ></circle>
          <circle
            cx="75.451"
            cy="75.451"
            r="75.451"
            fill="#fff"
            data-name="Ellipse 1463"
            transform="translate(16387.162 8318.765)"
          ></circle>
          <circle
            cx="10.078"
            cy="10.078"
            r="10.078"
            fill="#3f3d56"
            data-name="Ellipse 1464"
            transform="translate(16452.264 8384.41)"
          ></circle>
          <path
            fill="#3f3d56"
            d="M0 0H4.358V8.172H0z"
            data-name="Rectangle 1491"
            transform="translate(16460.164 8322.578)"
          ></path>
          <path
            fill="#3f3d56"
            d="M0 0H4.358V8.172H0z"
            data-name="Rectangle 1492"
            transform="translate(16460.164 8458.227)"
          ></path>
          <path
            fill="#3f3d56"
            d="M0 0H4.358V8.172H0z"
            data-name="Rectangle 1493"
            transform="rotate(90 4003.147 12395.457)"
          ></path>
          <path
            fill="#3f3d56"
            d="M0 0H4.358V8.172H0z"
            data-name="Rectangle 1494"
            transform="rotate(90 4070.971 12463.281)"
          ></path>
          <path
            fill="#3f3d56"
            d="M450.924 313.009l3.725-8.516 46.669 25.847z"
            data-name="Path 5760"
            transform="translate(16008.513 8085.854)"
          ></path>
          <path
            fill="#3f3d56"
            d="M0 0H21.246V24.515H0z"
            data-name="Rectangle 1495"
            transform="translate(16451.992 8292.071)"
          ></path>
          <ellipse
            cx="24.515"
            cy="6.81"
            fill="#3f3d56"
            data-name="Ellipse 1465"
            rx="24.515"
            ry="6.81"
            transform="translate(16438.1 8285.262)"
          ></ellipse>
        </g>
      </g>
    </svg>
  );
}

export default PaymentPendingIllustration;
